import i18next from 'i18next';

export default function initI18n(): void {
  i18next.addResourceBundle('en', 'podcast-ui', {
    episodeDetailsTab: 'Episode Details',
    podcastDetailsTab: 'Podcast Details',
    resourceLinksTab: 'Resource Links',
    editDescription: 'Edit Description',
    saveDescription: 'Save Description',
    podEpisodesPageTitle: 'Pod Episodes',
    publishSelectedEpisodes: 'Publish selected episodes',
    unpublishSelectedEpisodes: 'Unpublish selected episodes',
    clearWarningsForSelectedEpisodes: 'Clear warnings for selected episodes',
    reindexSelectedEpisodes: 'Reindex selected episodes',
    enrichSelectedEpisodes: 'Enrich selected episodes',
    deleteSelectedEpisodes: 'Delete selected episodes',
    addMoreEpisodes: 'Add more episodes',
    reindexEpisode: 'Reindex episode',
    enrichEpisode: 'Enrich episode',
    transcribeEpisode: 'Transcribe episode',
    clearWarnings: 'Clear warnings',
    deleteEpisode: 'Delete episode',
    publishSelectedPodcasts: 'Publish selected podcasts',
    unpublishSelectedPodcasts: 'Unpublish selected podcasts',
    clearWarningsForSelectedPodcasts: 'Clear warnings for selected podcasts',
    deleteEpisodesForSelectedPodcasts: 'Delete episodes for selected podcasts',
    deleteSelectedPodcasts: 'Delete selected podcasts',
    openInEditor: 'Open in editor',
    addResourceLink: 'Add resource link',
    addEpisodes: 'Add episodes',
    publishAllEpisodes: 'Publish all episodes',
    unpublishAllEpisodes: 'Unpublish all episodes',
    repairLastEpisodeDate: 'Repair last episode date',
    deleteEpisodes: 'Delete episodes',
    deletePodcast: 'Delete podcast',
    browserNoAudioSupport: 'Your browser does not support the audio element.',
    noAudioOrVideoAvailable: 'No audio or video available',
    noTranscriptAvailable: 'No transcript available',
    editTranscriptText: 'Edit transcript text',
    saveTranscriptText: 'Save transcript text',
    addEpisodesButtonTitle: 'Add Episodes',
    addPodcastButtonTitle: 'Add Podcast',

    // Generic actions / nouns (reused across confirm dialogs)
    delete: 'Delete',
    cancel: 'Cancel',
    publish: 'Publish',
    unpublish: 'Unpublish',
    enrich: 'Enrich',
    reindex: 'Reindex',
    clearWarningsForAction: 'Clear Warnings for',
    deleteEpisodesForAction: 'Delete Episodes for',
    episode: 'Episode',
    episodes: 'Episodes',
    podcast: 'Podcast',
    podcasts: 'Podcasts',

    // Shared dialogs / snacks
    numberOfEpisodesToIndexDescription: 'Enter the number of episodes to index.',
    startedIndexingEpisodes: 'Started indexing {{count}} podcast episode',
    startedIndexingEpisodes_plural: 'Started indexing {{count}} podcast episodes',
    warningsCleared: 'Warnings cleared',
    descriptionUpdatedSuccess: 'Description updated successfully',
    transcriptTextUpdatedSuccess: 'Transcript text updated successfully',

    // PodEpisodeDetailPanel
    episodeNotFound: 'Episode not found',

    // PodEpisodeGrid
    episodePublished: 'Episode published',
    episodeUnpublished: 'Episode unpublished',
    uploadMoreEpisodesTitle: 'Upload More Episodes',
    podEpisodeEnrichmentJobStarted: 'Podcast episode enrichment job started',
    podEpisodeReindexingJobStarted: 'Podcast episode re-indexing job started',
    podEpisodeTranscriptionJobStarted: 'Podcast episode transcription job started',
    deleteEpisodeConfirmTitle: 'Delete Episode',
    deleteEpisodeConfirmDescription:
      'Are you sure you want to delete "{{title}}"? This action cannot be undone.',
    deleteEpisodesDescriptionSuffix: ' This action cannot be undone.',
    episodeDeleted: 'Episode deleted',
    episodesDeletedCount: '{{count}} episode deleted',
    episodesDeletedCount_plural: '{{count}} episodes deleted',
    episodesPublishedCount: '{{count}} episode published',
    episodesPublishedCount_plural: '{{count}} episodes published',
    episodesUnpublishedCount: '{{count}} episode unpublished',
    episodesUnpublishedCount_plural: '{{count}} episodes unpublished',
    warningsClearedForCount: 'Warnings cleared for {{count}} episode',
    warningsClearedForCount_plural: 'Warnings cleared for {{count}} episodes',
    enrichmentJobStartedForCount: 'Started enrichment job for {{count}} episode',
    enrichmentJobStartedForCount_plural: 'Started enrichment job for {{count}} episodes',
    reindexingJobStartedForCount: 'Started reindexing job for {{count}} episode',
    reindexingJobStartedForCount_plural: 'Started reindexing job for {{count}} episodes',

    // PodcastGrid
    podcastPublished: 'Podcast published',
    podcastUnpublished: 'Podcast unpublished',
    addResourceLinkDialogTitle: 'Add Resource Link',
    addResourceLinkDialogDescription:
      'Enter the RSS feed URL to add to the podcast as an additional resource link',
    podcastEnrichmentJobStarted: 'Podcast enrichment job started',
    deletePodcastEpisodesConfirmTitle: 'Delete Podcast Episodes',
    deletePodcastEpisodesConfirmDescription:
      'Are you sure you want to delete all {{count}} episodes for "{{title}}"? This action cannot be undone.',
    noReviewEpisodesFound: 'No episodes found with status "review" and no warnings for "{{title}}"',
    publishEpisodesConfirmTitle: 'Publish {{count}} Episode',
    publishEpisodesConfirmTitle_plural: 'Publish {{count}} Episodes',
    publishEpisodesConfirmDescription:
      'Are you sure you want to publish {{count}} episode for "{{title}}" with status "review" and no warnings.',
    publishEpisodesConfirmDescription_plural:
      'Are you sure you want to publish {{count}} episodes for "{{title}}" with status "review" and no warnings.',
    episodesPublishedForPodcast: '{{count}} episode published for "{{title}}"',
    episodesPublishedForPodcast_plural: '{{count}} episodes published for "{{title}}"',
    noPublishedEpisodesFound: 'No published episodes found for "{{title}}"',
    unpublishEpisodesConfirmTitle: 'Unpublish {{count}} Episode',
    unpublishEpisodesConfirmTitle_plural: 'Unpublish {{count}} Episodes',
    unpublishEpisodesConfirmDescription:
      'Are you sure you want to unpublish {{count}} episode for "{{title}}"?',
    unpublishEpisodesConfirmDescription_plural:
      'Are you sure you want to unpublish {{count}} episodes for "{{title}}"?',
    episodesUnpublishedForPodcast: '{{count}} episode unpublished for "{{title}}"',
    episodesUnpublishedForPodcast_plural: '{{count}} episodes unpublished for "{{title}}"',
    lastEpisodeDateRepaired: 'Last episode date repaired',
    deletePodcastConfirmTitle: 'Delete Podcast',
    deletePodcastConfirmDescription:
      'Are you sure you want to delete "{{title}}" and all associated episodes? This action cannot be undone.',
    deletePodcastsAlsoSuffix:
      ' This will also delete all their episodes. This action cannot be undone.',
    podcastDeleted: 'Podcast deleted',
    podcastsDeletedCount: '{{count}} podcast deleted',
    podcastsDeletedCount_plural: '{{count}} podcasts deleted',
    podcastsPublishedCount: '{{count}} podcast published',
    podcastsPublishedCount_plural: '{{count}} podcasts published',
    podcastsUnpublishedCount: '{{count}} podcast unpublished',
    podcastsUnpublishedCount_plural: '{{count}} podcasts unpublished',
    warningsClearedForPodcastCount: 'Warnings cleared for {{count}} podcast',
    warningsClearedForPodcastCount_plural: 'Warnings cleared for {{count}} podcasts',
    deleteEpisodesForTitleMatching: 'Delete episodes for all {{count}} matching {{noun}}',
    deleteEpisodesForTitleSelected: 'Delete episodes for {{count}} selected {{noun}}',
    deleteEpisodesForDescriptionMatching:
      'Are you sure you want to delete all episodes for all {{count}} matching {{nounLower}}? This action cannot be undone.',
    deleteEpisodesForDescriptionSelected:
      'Are you sure you want to delete all episodes for the {{count}} selected {{nounLower}}? This action cannot be undone.',
    episodesDeletedForPodcastCount: 'Episodes deleted for {{count}} podcast',
    episodesDeletedForPodcastCount_plural: 'Episodes deleted for {{count}} podcasts',

    // UploadPodEpisodeButton
    addEpisodesByIdDialogDescription:
      'Enter the ID of the Podcast to index episodes for, and how many episodes to index.',

    // UploadPodcastButton
    addPodcastDialogDescription: 'Enter the RSS feed URL for the podcast',
    podcastIndexingJobStarted: 'Podcast indexing job started',
  });
}
